import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

interface IWrapperProps {
  pdfExport?: boolean;
}

const Wrapper = styled.div`
  height: 480px;
  width: ${(props: IWrapperProps) => props.pdfExport && "400px"};
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  position: relative;
  box-shadow: ${(props: IWrapperProps) =>
    !props.pdfExport && "rgb(220, 220, 220) 0px 0px 15px;"};
  margin: 0 10px;
  overflow: hidden;
  transform: ${(props: IWrapperProps) =>
    props.pdfExport && "scale(0.9) translateX(30px) translateY(-3px)"};

  &.animated.delay-2 {
    animation-delay: 0.3s;
  }

  ${mediaMaxWidth.mediumDesktop} {
    margin: ${(props: IWrapperProps) => !props.pdfExport && "0 auto 10px auto"};
    width: ${(props: IWrapperProps) => !props.pdfExport && "650px"};
  }

  ${mediaMaxWidth.tablet} {
    width: ${(props: IWrapperProps) => !props.pdfExport && "unset"};
    margin: ${(props: IWrapperProps) => !props.pdfExport && "0 20px 10px 20px"};
  }

  ${mediaMaxWidth.phone} {
    margin: ${(props: IWrapperProps) => !props.pdfExport && "0 10px"};
    height: ${(props: IWrapperProps) => !props.pdfExport && "450px"};
  }

  ${mediaMaxWidth.smallPhone} {
    height: ${(props: IWrapperProps) => !props.pdfExport && "380px"};
  }
`;

export { Wrapper as default };
